const Cart = () => import(/* webpackChunkName: "cart" */ '@/modules/cart/views/Cart')

export default [
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: {
      title: 'Shopping Cart'
    }
  }
]
